/**
 * @file jobSearchRoutes.jsx
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Feb 01, 2026 09:14
 */
import { lazy } from 'react';

import Loader from './Loader';

const JobSearch = Loader(
    lazy(() => import('src/content/Job/search/SearchContainer'))
);

const jobsRoutes = [
    {
        path: '',
        element: <JobSearch />
    },
];

export default jobsRoutes;